import { Component } from '@verndale/core';
import Swiper, { Pagination } from 'swiper';
import { breakpoints } from '../helpers';

Swiper.use([Pagination]);

class ContentWithIconRow extends Component {
  setupDefaults() {
    this.dom = {
      swiperContainer: this.el.querySelector(
        '.content-with-icon-row__swiper-container'
      ),
      swiperSlides: this.el.querySelectorAll(
        '.content-card-with-icon__swiper-slide'
      ),
      swiperWrapper: this.el.querySelector('.swiper-wrapper')
    };
    this.init = false;
    this.mobile = window.matchMedia(`(max-width: ${breakpoints.tablet - 1}px)`);

    this.initSlider();
  }

  initSlider() {
    this.init = true;
    if (this.dom.swiperWrapper.classList.contains('grid')) {
      this.dom.swiperWrapper.classList.remove('grid');
    }
    this.swiper = new Swiper(this.dom.swiperContainer, {
      slidesPerView: 1,
      slidesPerGroup: 1
    });
  }

  addListeners() {
    window.addEventListener('resize', this.resize.bind(this));
  }

  resize() {
    if (this.mobile.matches && !this.init) {
      this.initSlider();
    }
    if (!this.mobile.matches && this.init) {
      this.init = false;
      this.swiper.destroy();
      if (!this.dom.swiperWrapper.classList.contains('grid')) {
        this.dom.swiperWrapper.classList.add('grid');
      }
      this.dom.swiperSlides.forEach(slide => {
        if (slide.hasAttribute('style')) {
          slide.removeAttribute('style');
        }
      });
    }
  }
}

export default ContentWithIconRow;
